import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { Product } from 'teacher-ui-client/utils/products'
import type ReadingEggspressDashboardStudentAssessmentsRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/assessments/route'

export interface Params extends Record<string, unknown> {
  pageNumber: number
  perPage: number
  sort: string
}

export default class RexDashboardStudentAssessmentsIndexRoute extends Route {
  @service router!: RouterService

  queryParams = {
    pageNumber: {
      replace: true,
      refreshModel: true,
    },
    perPage: {
      replace: true,
      refreshModel: true,
    },
    sort: {
      replace: true,
      refreshModel: true,
    },
  }

  model({ pageNumber, perPage, sort }: Params) {
    const { requestScope, period, fetchAssessmentsOverviewReportTask, fetchAssessmentsEventsReportTask } =
      this.modelFor(
        'reporting.ui-scope.rex.dashboard.student.assessments',
      ) as ModelFor<ReadingEggspressDashboardStudentAssessmentsRoute>

    // Reset the page number for events if the overview task is running
    if (pageNumber !== 1 && fetchAssessmentsOverviewReportTask.isRunning) {
      void this.router.transitionTo({ queryParams: { pageNumber: 1 } })
      return {
        fetchAssessmentsOverviewReportTask,
        fetchAssessmentsEventsReportTask,
      }
    }

    void fetchAssessmentsEventsReportTask
      .perform(Product.REX, sort, { number: pageNumber, size: perPage }, period, requestScope)
      .catch(() => {})

    return {
      fetchAssessmentsOverviewReportTask,
      fetchAssessmentsEventsReportTask,
    }
  }
}
